// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PingAnswerStyles-cls1__afe1b1070f79c3dd844d{/*!*/}.PingAnswerStyles-cls2__fccde3c697fb9c2b9910{font-family:\"Roboto\";font-style:normal;font-weight:400;font-size:14px;line-height:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PingAnswerStyles-cls1__afe1b1070f79c3dd844d",
	"cls2": "PingAnswerStyles-cls2__fccde3c697fb9c2b9910 PingAnswerStyles-cls1__afe1b1070f79c3dd844d"
};
export default ___CSS_LOADER_EXPORT___;
